module.exports = __webpack_public_path__ + "img/terms_and_conditions.516288a0.svg";